import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent, setViewModel, MedicalProfessionalPersonalInfoViewModel } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepMedicalProfessionalPersonalInfoComponent } from './components/Steps/StepMedicalProfessionalPersonalInfoComponent';
import { StepDocUploadComponent } from './components/Steps/StepDocUploadComponent';
import { StepErrorComponent } from './components/Steps/StepErrorComponent';

const viewModel: MedicalProfessionalPersonalInfoViewModel = {
    status: 'NURSE',
    birthDate: '',
    postalCode: '',
    firstName: '',
    lastName: '',
    organization: { id: 0, name: '' },
    email: '',
    countryChoice: { value: 'US', label: '' },
    localeChoice: { value: 'en-US', label: '' },
};

setOptions(defaultOptions);
googleTagManagerHook();
setViewModel(viewModel);

// @ts-ignore
overrideComponent('StepMedicalProfessionalPersonalInfoComponent', StepMedicalProfessionalPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepErrorComponent', StepErrorComponent);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
